// extracted by mini-css-extract-plugin
export var circle = "_20-2";
export var icon = "_20-a";
export var iconHighlight = "_20-0";
export var lg = "_20-8";
export var md = "_20-7";
export var outline = "_20-4";
export var sm = "_20-6";
export var square = "_20-1";
export var xl = "_20-9";
export var xs = "_20-5";
export var xxs = "_20-3";